export type PredictionDisplayConfig = {
  backgroundImageUrl?: string | null
  /** 0 = ไม่ทับดำ, 1 = ทึบดำสนิท */
  backgroundOverlayOpacity?: number
}

export const DEFAULT_PREDICTION_DISPLAY_CONFIG: PredictionDisplayConfig = {
  backgroundImageUrl: null,
  backgroundOverlayOpacity: 0.6,
}

export function normalizePredictionDisplayConfig(
  input?: PredictionDisplayConfig | null,
): PredictionDisplayConfig {
  if (!input) return { ...DEFAULT_PREDICTION_DISPLAY_CONFIG }
  const opacity = Number(input.backgroundOverlayOpacity)
  return {
    backgroundImageUrl: input.backgroundImageUrl?.trim() || null,
    backgroundOverlayOpacity: Number.isFinite(opacity)
      ? Math.min(1, Math.max(0, opacity))
      : DEFAULT_PREDICTION_DISPLAY_CONFIG.backgroundOverlayOpacity,
  }
}

export function overlayOpacityPercent(config?: PredictionDisplayConfig | null): number {
  const normalized = normalizePredictionDisplayConfig(config)
  return Math.round((normalized.backgroundOverlayOpacity ?? 0.6) * 100)
}

export function overlayOpacityFromPercent(percent: number): number {
  return Math.min(1, Math.max(0, percent / 100))
}
